import { render, staticRenderFns } from "./classBag.vue?vue&type=template&id=2439627d&"
import script from "./classBag.vue?vue&type=script&lang=js&"
export * from "./classBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports